import React from 'react'

import { number } from 'prop-types'

function CustomRoyaltyBox({ levelRoyaltyRate }) {
  return (
    <div className="overview__royalty-box-wrapper">
      <div className="overview__royalty-box">
        <div className="overview__royalty-box-row">
          Your payout rate is <b>{levelRoyaltyRate || 0}%</b> (custom agreement).
        </div>
      </div>
    </div>
  )
}

CustomRoyaltyBox.propTypes = {
  levelRoyaltyRate: number.isRequired,
}

export default CustomRoyaltyBox
